// extracted by mini-css-extract-plugin
export default {"form":"AddWish_form__zUzi6"};